export function* takeN<T>(iterable: Iterable<T>, n: number): Iterable<T> {
  for (const [item, index] of withIndex(iterable)) {
    if (index == n) return;
    yield item;
  }
}

export function first<T>(iterable: Iterable<T>): T | undefined {
  for (const item of iterable) return item;
  return undefined;
}

export function* dropN<T>(iterable: Iterable<T>, n: number): Iterable<T> {
  for (const [item, index] of withIndex(iterable)) {
    if (index >= n) {
      yield item;
    }
  }
}

export function* withIndex<T>(iterable: Iterable<T>): Iterable<[T, number]> {
  let index = 0;
  for (const item of iterable) {
    yield [item, index];
    index++;
  }
}

export function* zip<T, K>(iterableA: Iterable<T>, iterableB: Iterable<K>): Iterable<[T, K]> {
  const genA = iterableA[Symbol.iterator]();
  const genB = iterableB[Symbol.iterator]();
  while (true) {
    const { done: doneA, value: valA } = genA.next();
    const { done: doneB, value: valB } = genB.next();
    if (doneA && doneB) return;
    yield [valA, valB];
  }
}

export function filterBy<T>(
  iterable: Generator<T, void, undefined>,
  filterFn: (element: T) => boolean
): Generator<T, void, undefined>;
export function filterBy<T, U extends T>(
  iterable: Generator<T, void, undefined>,
  filterFn: (element: T) => element is U
): Generator<U, void, undefined>;
export function* filterBy<T>(
  iterable: Generator<T, void, undefined>,
  filterFn: (element: T) => boolean
): Generator<T, void, undefined> {
  for (const item of iterable) {
    if (filterFn(item)) {
      yield item;
    }
  }
}

export function* mapBy<T, K>(iterable: Iterable<T>, mapFn: (element: T) => K): Iterable<K> {
  for (const item of iterable) {
    yield mapFn(item);
  }
}

/**
 * Set intersection: returns a new `Set` containing values present in both `a`
 * and `b`. Lodash's `_.intersection` only handles arrays (O(n·m)); this is
 * O(min(|a|, |b|)) using `Set.has`. Iterates the smaller set for fewer probes.
 */
export function setIntersect<T>(a: ReadonlySet<T>, b: ReadonlySet<T>): Set<T> {
  const [smaller, larger] = a.size <= b.size ? [a, b] : [b, a];
  const result = new Set<T>();
  for (const value of smaller) {
    if (larger.has(value)) result.add(value);
  }
  return result;
}
